import {createAction, ActionCreator} from '@packages/utilities/create-action';
import type {LibraryTagStylesSettings} from '../tagStyles';
import {
  LibraryVersionedResource,
  InstallLibraryTaskData,
  UninstallLibraryTaskData,
} from '../types';

export const PUBLISH_SITE_LIBRARY_FINISHED =
  'PUBLISH_SITE_LIBRARY_FINISHED' as const;

export const libraryPublishFinished: ActionCreator<
  typeof PUBLISH_SITE_LIBRARY_FINISHED,
  {
    library: LibraryVersionedResource;
  }
> = createAction(PUBLISH_SITE_LIBRARY_FINISHED);

export const MULTIPLAYER_LIBRARY_INSTALL_STARTED_REMOTELY =
  'MULTIPLAYER_LIBRARY_INSTALL_STARTED_REMOTELY';
export const MULTIPLAYER_LIBRARY_INSTALL_FINISHED_REMOTELY =
  'MULTIPLAYER_LIBRARY_INSTALL_FINISHED_REMOTELY';
export const MULTIPLAYER_LIBRARY_UNINSTALL_STARTED_REMOTELY =
  'MULTIPLAYER_LIBRARY_UNINSTALL_STARTED_REMOTELY';
export const MULTIPLAYER_LIBRARY_UNINSTALL_FINISHED_REMOTELY =
  'MULTIPLAYER_LIBRARY_UNINSTALL_FINISHED_REMOTELY';
export const MULTIPLAYER_PUSH_LIBRARY_UPDATE_STATUS_CHANGED_REMOTELY =
  'MULTIPLAYER_PUSH_LIBRARY_UPDATE_STATUS_CHANGED_REMOTELY';

export const multiplayerLibraryInstallStartedRemotely: ActionCreator<
  typeof MULTIPLAYER_LIBRARY_INSTALL_STARTED_REMOTELY,
  InstallLibraryTaskData
> = createAction(MULTIPLAYER_LIBRARY_INSTALL_STARTED_REMOTELY);

export const multiplayerLibraryInstallFinishedRemotely: ActionCreator<
  typeof MULTIPLAYER_LIBRARY_INSTALL_FINISHED_REMOTELY,
  void
> = createAction(MULTIPLAYER_LIBRARY_INSTALL_FINISHED_REMOTELY);

export const multiplayerLibraryUninstallStartedRemotely: ActionCreator<
  typeof MULTIPLAYER_LIBRARY_UNINSTALL_STARTED_REMOTELY,
  UninstallLibraryTaskData
> = createAction(MULTIPLAYER_LIBRARY_UNINSTALL_STARTED_REMOTELY);

export const multiplayerLibraryUninstallFinishedRemotely: ActionCreator<
  typeof MULTIPLAYER_LIBRARY_UNINSTALL_FINISHED_REMOTELY,
  void
> = createAction(MULTIPLAYER_LIBRARY_UNINSTALL_FINISHED_REMOTELY);

export const multiplayerPushLibraryUpdateStatusChangedRemotely: ActionCreator<
  typeof MULTIPLAYER_PUSH_LIBRARY_UPDATE_STATUS_CHANGED_REMOTELY,
  {
    sharedResourceProfileId: string;
  }
> = createAction(MULTIPLAYER_PUSH_LIBRARY_UPDATE_STATUS_CHANGED_REMOTELY);

export const MULTIPLAYER_LIBRARY_TAG_STYLES_SETTINGS_UPDATED_REMOTELY =
  'MULTIPLAYER_LIBRARY_TAG_STYLES_SETTINGS_UPDATED_REMOTELY' as const;

export const multiplayerLibraryTagStylesSettingsUpdatedRemotely: ActionCreator<
  typeof MULTIPLAYER_LIBRARY_TAG_STYLES_SETTINGS_UPDATED_REMOTELY,
  {
    libraryTagStylesSettings: LibraryTagStylesSettings[];
  }
> = createAction(MULTIPLAYER_LIBRARY_TAG_STYLES_SETTINGS_UPDATED_REMOTELY);

export const LIBRARY_PROFILE_UNSHARED = 'LIBRARY_PROFILE_UNSHARED' as const;

export const libraryProfileUnshared: ActionCreator<
  typeof LIBRARY_PROFILE_UNSHARED,
  {
    profileId: string;
  }
> = createAction(LIBRARY_PROFILE_UNSHARED);

export const MULTIPLAYER_SITE_LIBRARY_CHANGED_REMOTELY =
  'MULTIPLAYER_SITE_LIBRARY_CHANGED_REMOTELY' as const;

export const multiplayerSiteLibraryChangedRemotely: ActionCreator<
  typeof MULTIPLAYER_SITE_LIBRARY_CHANGED_REMOTELY,
  {
    profileId: string;
  }
> = createAction(MULTIPLAYER_SITE_LIBRARY_CHANGED_REMOTELY);
